import { Axios } from 'utils'
import { ItemResponseType } from './types'

export const useNirService = (prefix?: 'flour' | 'baker') => {
  const _uploadFile = async (file: File, params?: Record<string, any>) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('params', JSON.stringify(params || {}))

    const response = await Axios.post<ItemResponseType<{ job_id: string }>>(
      `${prefix ? `/${prefix}` : ''}/nirs/upload_file_async`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    )

    return response.data
  }

  const openNirUploadStream = (jobId: string, handlers: any) => {
    const base = (Axios as any)?.defaults?.baseURL?.replace(/\/+$/, '') || ''
    const path = `${prefix ? `/${prefix}` : ''}/nirs/upload_stream/${jobId}`
    const url = `${base}${path}`
    const es = new EventSource(url, { withCredentials: true })

    es.onopen = () => handlers?.onOpen?.()
    es.onerror = (err) => {
      console.error('SSE error', err)
      handlers?.onError?.(err)
      es.close()
    }
    es.onmessage = (e) => {
      try {
        handlers?.onEvent?.(JSON.parse(e.data))
      } catch {
        handlers?.onEvent?.(e.data)
      }
    }

    return { close: () => es.close() }
  }

  const uploadFileAndStream = async (
    file: File,
    params: Record<string, any> | undefined,
    handlers?: {
      onEvent?: (event: any) => void
      onOpen?: () => void
      onError?: (err: any) => void
    }
  ) => {
    const resp = await _uploadFile(file, params)
    const jobId = resp?.result?.job_id
    if (!jobId) throw new Error('No job_id returned')

    localStorage.setItem(`${prefix ? prefix : 'wheat'}_nir_job_id`, jobId)

    const controller = openNirUploadStream(jobId, {
      ...handlers,
      onEvent: (evt: any) => {
        handlers?.onEvent?.(evt)

        const type = evt?.type?.toLowerCase()
        if (
          ['done', 'completed', 'success', 'failed', 'error'].includes(type)
        ) {
          localStorage.removeItem(`${prefix ? prefix : 'wheat'}_nir_job_id`)
          controller.close()
        }
      },
      onError: (err: any) => {
        if (err?.status === 404 || err?.message?.includes('404')) {
          localStorage.removeItem(`${prefix ? prefix : 'wheat'}_nir_job_id`)
        }
        handlers?.onError?.(err)
      },
    })

    return { jobId, controller }
  }

  return {
    openNirUploadStream,
    uploadFileAndStream,
  }
}
